<template>
    <b-tr v-bind="$props">
        <slot />
    </b-tr>
</template>

<script>
import { BTr } from 'bootstrap-vue'

export default {
    components: { BTr },
    props: {}
}
</script>